import { ICostSummaryItem, ILineItem } from '../CartContext.types';
import { useDevicePaymentHook } from './Device/DevicePaymentHook';
import { usePromoDiscountHook } from './Device/PromoDiscountHook';
import { useTradeInHook } from './Device/TradeInHook';
export const generateDueTodayDeviceCosts = (
    lineItem: ILineItem,
    summaryList: ICostSummaryItem[]
) => {
    summaryList.push(useDevicePaymentHook(lineItem, 'dueToday'));

    const promoDiscount = usePromoDiscountHook(lineItem, 'dueToday');
    if (promoDiscount) {
        summaryList.push(promoDiscount);
    }

    const tradeIn = useTradeInHook(lineItem, 'dueToday');
    if (tradeIn) {
        summaryList.push(tradeIn);
    }
};
